import * as React from 'react';

import { Dropdown } from '@fluentui/react';

import { RootState } from '../../redux/types';
import { useDispatch, useSelector } from 'react-redux';
import { setVisitStatus } from '../../redux/ui/actions';
import { useEffect, useState } from 'react';

const options = [
  { key: 'COMPLETED', text: 'Completed' },
  { key: 'CANCELLED', text: 'Cancelled' },
  { key: 'SCHEDULED', text: 'Scheduled' },
  { key: 'ACTIVE', text: 'Active' },
  { key: 'STARTED', text: 'Started' },
  { key: 'NOT_FINISHED', text: 'Not Finished' },
  { key: 'ALL', text: 'All' },
];

export const VisitStatusSelector = ({ hideLabel }: { hideLabel?: boolean }) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(useSelector((state: RootState) => state.ui.visitStatus));

  useEffect(() => {
    dispatch(setVisitStatus(status));
  }, [dispatch, status]);

  return (
    <Dropdown
      style={{ width: 170 }}
      label={hideLabel ? undefined : 'Status'}
      selectedKey={status}
      options={options}
      onChange={(e, o) => setStatus(o!.key as string)}
      data-tid="dd_visitStatus"
    />
  );
};
